/** @format */

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ONBOARDING_PAGE_ID } from 'src/constants';
import { HelpIcon, SettingIcon, ExitIcon } from 'src/components/icons';

export const UserDropdown = props => {
  const { logout } = props;
  const { t } = useTranslation();

  return (
    <>
      <ul className="custom-dropdown__menu custom-dropdown__menu--user" role="menu">
        <li className="custom-dropdown__menu-item" role="none">
          <Link className="menu-profile" role="menuitem" to="/profile">
            <SettingIcon aria-hidden />
            {t('menu.profile')}
          </Link>
        </li>
        <li className="custom-dropdown__menu-item" role="none">
          <Link className="menu-help" role="menuitem" to={`/page/${ONBOARDING_PAGE_ID}`}>
            <HelpIcon aria-hidden />
            {t('menu.help')}
          </Link>
        </li>
        <li className="custom-dropdown__menu-item" role="presentation">
          <span className="separate" aria-hidden="true" />
        </li>
        <li className="custom-dropdown__menu-item" role="none">
          <a
            className="menu-logout"
            role="menuitem"
            href="/"
            onClick={e => {
              e.preventDefault();
              logout();
            }}>
            <ExitIcon width={20} height={18} color="#234D96" aria-hidden />
            {t('menu.logout')}
          </a>
        </li>
      </ul>
    </>
  );
};
